import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import { TabNav as TabNav$2, TabNavButton } from './style.js';
import { jsx } from 'react/jsx-runtime';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TabNav = function TabNav(_ref) {
  var className = _ref.className,
    tabs = _ref.tabs,
    selected = _ref.selected,
    _onClick = _ref.onClick;
  var _useState = useState(selected),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  useEffect(function () {
    setSelectedTab(selected);
  }, [selected]);
  if (!tabs || !tabs.length) {
    return null;
  }
  return /*#__PURE__*/jsx(TabNav$2, {
    className: className,
    isMultiple: tabs.length > 2,
    children: tabs.filter(function (t) {
      return t;
    }).map(function (tab, i) {
      return /*#__PURE__*/jsx(TabNavButton, _objectSpread(_objectSpread({
        onClick: function onClick() {
          if (!tab.disabled) {
            _onClick(i);
            setSelectedTab(i);
          }
        },
        type: "button",
        isDisabled: tab.disabled,
        isSelected: selectedTab === i
      }, tab.attribute ? _defineProperty({}, tab.attribute.name, tab.attribute.value) : {}), {}, {
        children: tab.value ? /*#__PURE__*/jsx("span", {
          dangerouslySetInnerHTML: {
            __html: tab.value
          }
        }) : tab
      }), i);
    })
  });
};
TabNav.defaultProps = {
  className: null,
  onClick: function onClick() {},
  selected: 0
};
var TabNav$1 = TabNav;

export { TabNav$1 as default };
//# sourceMappingURL=TabNav.js.map
